// Helper para extraer información del token JWT de sesión
export const obtenerDatosToken = () => {
  try {
    const token = localStorage.getItem('token');
    if (!token) return null;
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    return JSON.parse(jsonPayload);
  } catch (e) {
    console.error('Error al decodificar token JWT:', e);
    return null;
  }
};

// Verifica si el usuario autenticado tiene rol de Administrador (Rol 2)
export const esRolAdmin = () => {
  const tokenData = obtenerDatosToken();
  return tokenData?.id_rol === 2;
};